export let PrivateSaleModalName;

(function (PrivateSaleModalName) {
  PrivateSaleModalName["AGREEMENT"] = "AGREEMENT";
  PrivateSaleModalName["CONFIRM_ORDER"] = "CONFIRM_ORDER";
  PrivateSaleModalName["ORDER_DETAIL"] = "ORDER_DETAIL";
  PrivateSaleModalName["CONNECT_WALLET"] = "CONNECT_WALLET";
  PrivateSaleModalName["REFUNDED_DETAIL"] = "REFUNDED_DETAIL";
})(PrivateSaleModalName || (PrivateSaleModalName = {}));